import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	{
		path: '/login',
		name: 'Login',
		component: () => import("../views/Login.vue")
	},
	{
		path: '/join/:token',
		name: 'Join',
		component: () => import("../views/Join.vue")
	},
	{
		path: '/download',
		name: "Download",
		component: () => import("../views/Download.vue")
	},
	{
		path: '/download2',
		name: "Download2",
		component: () => import("../views/Download2.vue")
	},
	{
		path: '/privacy',
		name: "Privacy",
		component: () => import("../views/Privacy.vue")
	},
	{
		path: '/',
		name: 'Main',
		component: () => import("../views/pages/Main.vue"),
		children: [
			{
				path: "/",
				name: 'Home',
				component: () => import("../views/pages/main/Home.vue"),
			},
			{
				path: "/projects",
				name: 'Projects',
				component: () => import("../views/pages/projects/Projects.vue"),
			},
			{
				path: "/projects/:id",
				name: 'Project',
				component: () => import("../views/pages/projects/Project.vue"),
			},
			{
				path: "/organize",
				name: 'organize',
				component: () => import("../views/pages/organize/organize.vue"),
			},
			{
				path: "/document/:id",
				name: 'document',
				component: () => import("../views/pages/projects/Document.vue"),
			},	{
				path: "/progress/:id",
				name: 'progress',
				component: () => import("../views/pages/projects/ProgressEdit.vue"),
			},	{
				path: "/progress/edit_building/:pid/:id",
				name: 'progress',
				component: () => import("../views/pages/projects/BuildingEdit.vue"),
			},	{
				path: "/auth",
				name: 'auth',
				component: () => import("../views/pages/auth/Auth.vue"),
			},	{
				path: "/notification",
				name: 'notification',
				component: () => import("../views/pages/notification/Notification.vue"),
			},	{
				path: "/contract/:id",
				name: 'contract',
				component: () => import("../views/pages/projects/Contract.vue"),
			},	{
				path: "/contract_detail/:project_id/:id",
				name: 'contract_detail',
				component: () => import("../views/pages/projects/ContractDetails.vue"),
			},	{
				path: "/collect/:project_id/",
				name: 'colloet',
				component: () => import("../views/pages/projects/Collect.vue"),
			}
		]
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
